import LangEnum from '../../../../../../../lang/LangEnum';
import { isPreOrder } from '../../../../../../products/utils/availability.utils';
import { OfflineOrderProduct } from '../../../orderProduct/OfflineOrderProduct';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  ValidateOfflineOrderRuleParams,
} from '../../OfflineOrderRules.types';
import BaseOrderProductQuantityRule from '../baseOrderProductQuantity.rule';

export default class PreOrderMinimumAmountByItemRule extends BaseOrderProductQuantityRule {
  validate({
    order,
    userRole,
  }: ValidateOfflineOrderRuleParams): OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS] {
    if (this.canUserBypassRule(userRole)) {
      return { hasErrors: false };
    }

    const filtered = this.filterOrderProducts(order.products ?? []);

    filtered.forEach((orderProduct) => {
      this.validateOrderProduct(orderProduct);
    });

    if (!this.orderProductsWithError.length) {
      return {
        hasErrors: false,
      };
    }

    return {
      hasErrors: true,
      error: { messageCode: LangEnum.ORDER_PRODUCT_RULE_PRE_ORDER_MINIMUM_AMOUNT_BY_ITEM },
      orderProductsWithError: this.orderProductsWithError,
    };
  }

  private filterOrderProducts(products: OfflineOrderProduct[]): OfflineOrderProduct[] {
    return products.filter(
      (orderProduct) =>
        isPreOrder(orderProduct.availability) && !!orderProduct.product.rules?.preOrderMinimumItem,
    );
  }

  private validateOrderProduct(orderProduct: OfflineOrderProduct) {
    const achievedQuantity = orderProduct.getTotalGridQuantity();
    const minimumQuantity = orderProduct.product.rules?.preOrderMinimumItem ?? 0;

    if (achievedQuantity < minimumQuantity) {
      this.pushOrderProductWithError(orderProduct, {
        achievedQuantity,
        minimumQuantity,
      });
    }
  }
}
